// @flow

export default (text) => {
    return text;
};
